import type { InjectionKey, Ref } from 'vue';

/** ContactDetailPage only — MY Residential editor vs summary (survives ContactAddressForm ↔ NoSync swap). */
export const contactDetailMyResidentialEditingKey: InjectionKey<Ref<boolean>> = Symbol(
    'contactDetailMyResidentialEditing'
);
